"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var RenewalDropdown_1 = __importDefault(require("./RenewalDropdown"));
var RenewalPopup_1 = __importDefault(require("./RenewalPopup"));
var AddButton_1 = __importDefault(require("./styles/AddButton"));
var RenewalDetails = function (_a) {
    var _b, _c;
    var serviceStat = _a.serviceStat;
    var _d = __read(react_1.default.useState(false), 2), popupVisibility = _d[0], setPopupVisibility = _d[1];
    var boxRef = react_1.default.useRef(null);
    var _e = __read(react_1.default.useState(null), 2), dropdownAnchor = _e[0], setDropdownAnchor = _e[1];
    var handleDropdownClick = function () {
        setDropdownAnchor(dropdownAnchor ? null : boxRef.current);
        setPopupVisibility(false);
    };
    var handleDropdownOnClose = function () { return setDropdownAnchor(null); };
    var toolName = ((_b = serviceStat.service) === null || _b === void 0 ? void 0 : _b.niceName) || ((_c = serviceStat.service) === null || _c === void 0 ? void 0 : _c.name);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "flex-end", ref: boxRef, mr: -2.25, onClick: function (e) { return e.stopPropagation(); } }, { children: [serviceStat.renewalDateNext
                ? ((0, jsx_runtime_1.jsx)(RenewalPopup_1.default, { toolName: toolName, billingFrequency: serviceStat.renewalFrequency, nextRenewalDate: (0, date_fns_1.format)(serviceStat.renewalDateNext.toDate(), 'dd/MM/yyyy'), popupVisibility: popupVisibility, handleMouseEnter: function () { return setPopupVisibility(true); }, handleMouseLeave: function () { return setPopupVisibility(false); }, handleDropdownClick: handleDropdownClick }))
                : ((0, jsx_runtime_1.jsx)(AddButton_1.default, __assign({ onClick: handleDropdownClick }, { children: serviceStat.activeStatus === 'Inactive' ? 'Canceled' : 'Add Renewal Date' }))), dropdownAnchor && ((0, jsx_runtime_1.jsx)(RenewalDropdown_1.default, { onClose: handleDropdownOnClose, dropdownAnchor: dropdownAnchor, serviceStat: serviceStat }))] })));
};
exports.default = RenewalDetails;
